import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { onErrorHandler } from './handlers';

declare const window: any;

export const inventoryApi = createApi({
    reducerPath: 'inventoryApi',
    baseQuery: fetchBaseQuery({
        baseUrl: window.Config?.INVENTORY_API ?? "https://npr-inventory.api.pens.com",
        prepareHeaders: (headers) => {
            return headers
        },
    }),
    tagTypes: ['inventory'],
    endpoints: (builder) => ({
        getInventoryDetails: builder.query({
            query: ({ productKey, country, filteredSelections }) => {
                const dynamicParams = {};
                Object.entries(filteredSelections || {}).forEach(([attributeKey, attributeValue]) => {
                    dynamicParams[`selectedAttributes.${attributeKey}`] = attributeValue as string;
                });
        
                return {
                    url: `/v1/inventory/${productKey}`,
                    params: {
                        country: country,
                        ...dynamicParams,
                    },
                    headers: {
                        'x-api-key': window.Config?.INVENTORY_API_CLIENT_KEY ?? 'lXVbotbvQF9YIPXIGToEk8zJcHEdhuaH7oyXNbmd',
                    },
                    method: 'GET',
                };
            },
            async onQueryStarted(args, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;
                    return data;
                }
                catch (error) {
                    console.log("Error: while fetching inventory details: ",error);
                    dispatch(onErrorHandler({operation: 'inventory getInventoryDetails', err: JSON.stringify(error), errMsg: 'Error: while fetching inventory details', api: `${window.Config.INVENTORY_API}`}));     
                }
            }
        }),
    }),
})

export const {
    useGetInventoryDetailsQuery
} = inventoryApi;